export default "/images/logo.svg?0c9a9cd318641387b2020e3ec8411cc8";